import json from '@/api/json'

const registered = async () => {
  return json.get(CP.env.routes.user_hackathons_url);
}

const recommended = async () => {
  return json.get(CP.env.routes.recommended_hackathons_url);
}

export default {
  registered,
  recommended
}
